export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7066.00b17121.jpg";